import { clsx } from 'clsx';
import { Badge } from '@/shared/ui/Badge';
import patterns from '@/shared/ui/styles/patterns.module.css';
import type { PatientReviewItem } from '../api/captureApi';
import { formatDate } from '../utils/formatDate';
import { StarRating } from './StarRating';
import { Avatar } from './Avatar';
import styles from './ReviewCard.module.css';

interface Props {
  review: PatientReviewItem;
}

export function PatientReviewCard({ review }: Props) {
  const isPrivate = review.channel === 'private';
  // Below-5-star Google hand-offs collect the same contact fields as private
  // feedback now (compliance requirement — see CapturePrivateScreen), so a
  // real name can show up on a Google-channel row too, not just private.
  const name = review.patientName || (isPrivate ? 'Anonymous' : 'Posted to Google');

  return (
    <div className={clsx(patterns.panel, styles.card)}>
      <div className={styles.header}>
        <div className={styles.author}>
          <Avatar name={isPrivate ? name : 'G'} photoUrl={null} />
          <div>
            <div className={styles.name}>{name}</div>
            <div className={styles.meta}>
              {review.rating != null && <StarRating rating={review.rating} />}
              {review.patientContact && (
                <span className={styles.date}>{review.patientContact}</span>
              )}
              <span className={styles.date}>{formatDate(review.createdAt)}</span>
            </div>
          </div>
        </div>
        <div className={styles.badges}>
          <Badge variant={isPrivate ? 'neutral' : 'info'}>{isPrivate ? 'Private' : 'Google'}</Badge>
        </div>
      </div>

      {review.body ? (
        <p className={styles.comment}>{review.body}</p>
      ) : (
        <p className={styles.noComment}>No review text recorded.</p>
      )}
    </div>
  );
}
